import { memo, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner';
import { OutletIProps } from '../../../components/sitebase/Base.types';


export default memo(function Redirector(params: { to: (context: OutletIProps) => string }) {
    const navigate = useNavigate();
    const context = useOutletContext<OutletIProps>();

    useEffect(() => {
        navigate(params.to(context));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot redirect on mount: the component navigates away immediately, so `navigate`/`params`/`context` never need re-tracking
    }, []);
    return (<>
        <LoadingSpinner />
    </>);
})